class Rectangle {
    x: number;

    y: number;

    width: number;

    height: number;

    constructor(_x: number = 0, _y: number = 0, _width: number = 0, _height: number = 0) {
      this.x = _x;
      this.y = _y;
      this.width = _width;
      this.height = _height;
    }

    /**
     * クローン
     */
    clone(): Rectangle {
      return new Rectangle(this.x, this.y, this.width, this.height);
    }

    /**
     * 合体
     */
    union(target: Rectangle): Rectangle {
      const minX: number = Math.min(this.x, target.x);
      const minY: number = Math.min(this.y, target.y);
      const maxX: number = Math.max(this.x + this.width, target.x + target.width);
      const maxY: number = Math.max(this.y + this.height, target.y + target.height);

      return new Rectangle(minX, minY, maxX - minX, maxY - minY);
    }

    /**
     * rect パラメーターで指定された Rectangle オブジェクトがこの Rectangle オブジェクト内にあるかどうかを判別します。
     */
    containsRect(targetRect: Rectangle): boolean {
      if (targetRect.x < this.x) return false;
      if (targetRect.y < this.y) return false;
      if (targetRect.x + targetRect.width > this.x + this.width) return false;
      if (targetRect.y + targetRect.height > this.y + this.height) return false;
      return true;
    }
}
export default Rectangle;
